export default {
    CONTACT: "contact"
}
